import { o_global } from "@gr-common/async/namespaces";
const events = o_global.events;
const eventQBus = o_global.eventQBus;
export {
  eventQBus,
  events
};
